// Core
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";

// Components

export type LayoutDefaultElement = HTMLDivElement;

export type LayoutDefaultProps = {
  title: string;
  className?: string;
};

export const LayoutDefault = React.forwardRef<
  LayoutDefaultElement,
  React.PropsWithChildren<LayoutDefaultProps>
>(({ children, className }, ref) => {
  const theme = useTheme();

  // const contentHeight = `calc(${theme.customLayoutHeight.rootHeight} - ${theme.customLayoutHeight.appNavBarHeight})`;

  return (
    <div
      ref={ref}
      className={className}
      style={{
        height: theme.customLayoutHeight.rootHeight
      }}
    >
      <Box
        id="main-content-container"
        sx={{
          height: "100vh",
          overflow: "auto",
          backgroundColor: "transparent"
        }}
      >
        {children}
      </Box>
    </div>
  );
});

export default LayoutDefault;
